import { select, getData, addClass, removeClass, hasClass, on, selectAll } from 'modules/dom'
import { map } from 'modules/utils'

const SELECTOR_FIELD_CHECKBOX = '.js-field__checkbox'
const SELECTOR_FIELD_SEARCH = '.js-field__input'
const CLASS_DISABLE_FIELD = 'field--hidden'

export default function (el) {
  const fieldCheckboxs = selectAll(SELECTOR_FIELD_CHECKBOX, el)
  const inputFilter = select(SELECTOR_FIELD_SEARCH, el)

  const DiactivatedField = function (element) {
    if (!hasClass(CLASS_DISABLE_FIELD, element)) {
      addClass(CLASS_DISABLE_FIELD, element)
    }
  }

  const ActivatedField = function (element) {
    if (hasClass(CLASS_DISABLE_FIELD, element)) {
      removeClass(CLASS_DISABLE_FIELD, element)
    }
  }

  const filter = function () {
    const filterValue = inputFilter.value.toLowerCase()
    map(el => {
      const value = getData('value', el).toLowerCase()
      if (value.search(filterValue) >= 0) {
        ActivatedField(el)
      } else {
        DiactivatedField(el)
      }
    }, fieldCheckboxs)
  }

  on('keyup', filter, inputFilter)
  on('change', filter, inputFilter)
}
